module.exports = __webpack_public_path__ + "img/br.06640314.svg";